import React, {useEffect, useRef, useState} from "react";

// ✅ Metric Card Component
const MetricCard = ({ title, value, change,color }) => (
  <div style={styles.metricCard(change,color)}>
    <h3 style={{ fontSize: "18px", fontWeight: "600", color: "white"}}>{title}</h3>
    <p style={{ fontSize: "24px", fontWeight: "700" ,color: "white"}}>{value}</p>
    <small style={{ color: "white" }}>
      {change !== null ? `${change > 0 ? `+${change}%` : `${change}%`} ` : ""}
    </small>
  </div>
);

const DisplayCards = ({cardList,color="#35acef"}) =>{
  return (
    <div style={styles.container}>
      {cardList.length > 0 ? (
        cardList.map((card) => (
          <MetricCard
            key={card.title}
            title={card.title}
            value={card.value}
            // change={card.change !== null ? card.change : ""}
            change={card.change}
            color={color}
          />
        ))
      ) : (
        <p>No available data.</p>
      )}
    </div>
  );
}

export default DisplayCards;

// ✅ CSS as JavaScript Object (but separate from JSX)
const styles = {
  metricCard: (change,color) => ({
    padding: "10px",
    border: "1px solid",
    borderRadius: "8px",
    width: "150px",
    textAlign: "center",
    backgroundColor: change > 0 ? "#23d777" : change < 0 ? "#e86767" : color,
    borderColor: change > 0 ? "#23d777" : change < 0 ? "#e86767" : color,
    boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.5)", // ✅ Adds a slight shadow below
  }),
  container: {
    display: "flex",
    flexWrap: "wrap", // ✅ Allows wrapping if too many cards
    gap: "16px",
    padding: "16px",
    justifyContent: "center",
  },
};